module.exports = __webpack_public_path__ + "img/Flag_of_Barbados.68cbe434.svg";